<div class="gps-connectivity">
  <div class="stats">
    <app-header-summary-card
      [text]="'Total deadzones'"
      [value]="count_dead()"
      [severityClass]="'danger'"
    />
  </div>

  <!-- Filters Grid -->
  <st-grid-filters
    [filters]="filters"
    [updatedControls]="updatedControls"
    (applyFilters)="onApplyFilters($event)"
    (filtersCleared)="onClearFilters()"
    [filterActionsPlacement]="'end'"
    [AllowUpdateFilterControls]="true"
    [filterToggleIcon]="'icon-funnel-simple'"
    [showTitleTag]="true"
    [customHeaderContentWithFilterButton]="true"
  >
  </st-grid-filters>

  <!-- Google Map (decoupled, minimal scaffolding) -->
  <app-google-map
    [height]="'60vh'"
    [width]="'100%'"
    [center]="mapCenter()"
    [zoom]="mapZoom()"
    [options]="defaultMapOptions"
    [polygons]="polygons()"
    (polygonClick)="onPolygonClick($event)"
  ></app-google-map>

  <!-- Legend -->
  <div class="legend-container">
    <div class="legend-row">
      <div class="legend-item">
        <span class="legend-dot legend-dot--low"></span>
        <span class="legend-text">Low or No GPS (0-70%)</span>
      </div>
      <div class="legend-item">
        <span class="legend-dot legend-dot--normal"></span>
        <span class="legend-text">Normal GPS (71-100%)</span>
      </div>
    </div>
  </div>

  <!-- Deadzones Details Dialog -->
  <app-deadzones-details-dialog
    [visible]="isDeadzonesDialogVisible()"
    (visibleChange)="isDeadzonesDialogVisible.set($event)"
    [zone]="selectedZone()"
    [header]="'Deadzone Details'"
  ></app-deadzones-details-dialog>
</div>
